import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SubpageHero } from '../../../../components/web/subpage-hero/subpage-hero';

export const IntroContact: React.FC = () => {
    const { t } = useTranslation();
    return <SubpageHero visual="contact" title="Máte dotaz?" description={t('pages.contact.heroDescription')} />;
};
